import React from 'react'

export default ({ color }) => (
  <svg viewBox="0 0 14 25">
    <path fill={color} d="M0.3,24.7l13.4-12.2L0.3,0.3L0.3,24.7z" />
  </svg>
)
